
import { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useInvestmentPageState = () => {
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState("portfolio");
  
  // Get parameters from URL if they exist
  const tabFromUrl = searchParams.get('tab');
  const amountFromUrl = searchParams.get('amount');
  const horizonFromUrl = searchParams.get('horizon');

  useEffect(() => {
    // Set active tab based on URL parameter if it exists
    if (tabFromUrl && ["portfolio", "policy", "operations"].includes(tabFromUrl)) {
      setActiveTab(tabFromUrl);
    }
  }, [tabFromUrl]);

  return {
    activeTab,
    setActiveTab,
    amountFromUrl,
    horizonFromUrl,
  };
};
